"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const brand_1 = require("services/master-data/brand");
const hopper_control_line_types_1 = require("./hopper-control-line.types");
const hopper_control_line_1 = require("services/configuration/hopper-control-line");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hopper_control_line_1._getHopperConfigData)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { inEdit: false, modified_date: new Date(item.modified_date), brand2_disabled: item.brand1_name ? false : true, brand3_disabled: item.brand2_name ? false : true });
            })
        };
        dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.SET_DATA_GRID, payload: payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const { mutationMode, dataItem } = payload;
    const response = yield (0, hopper_control_line_1._putHopperConfigData)({
        brand1_id: (_a = dataItem.brand1_data) === null || _a === void 0 ? void 0 : _a.id,
        brand2_id: (_b = dataItem.brand2_data) === null || _b === void 0 ? void 0 : _b.id,
        brand3_id: (_c = dataItem.brand3_data) === null || _c === void 0 ? void 0 : _c.id,
        checkpoint_id: dataItem.checkpoint_id,
        dumping_type_id: (_d = dataItem.dumping_data) === null || _d === void 0 ? void 0 : _d.id
    });
    if (response.isError) {
        dispatch({
            type: hopper_control_line_types_1.hopperConfigTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: hopper_control_line_types_1.hopperConfigTypes.ON_SAVE_DATAITEM,
            payload: {
                mutationMode,
                dataItem,
                isSuccess: true,
            }
        });
    }
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: hopper_control_line_types_1.hopperConfigTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onEnterEditClick = (payload) => dispatch => {
    dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.ON_ENTER_EDIT_CLICK, payload });
};
const getDataBrand = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = {
        skip: 0,
        take: 1000,
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
        sort: [{ 'field': 'code', 'dir': 'asc' }],
        total: 0,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'scrollable'
    };
    const response = yield (0, brand_1._getBrandData)(payload);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            dataBrand: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.SET_DATA_BRAND, payload: payload });
    }
});
const getDataEnumDumping = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hopper_control_line_1._getEnumDumpingData)();
    if (response.isError) {
        dispatch({
            type: hopper_control_line_types_1.hopperConfigTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Enum Dumping Data. \n'.concat(response.errorMessage),
            }
        });
    }
    else {
        const payload = {
            dataDumping: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: hopper_control_line_types_1.hopperConfigTypes.SET_DATA_ENUM_DUMPING, payload: payload });
    }
});
exports.default = {
    getDataGrid,
    getDataBrand,
    onSortChange,
    onCloseError,
    onFilterChange,
    onSaveDataItem,
    onClickMutation,
    onEnterEditClick,
    onDataStateChange,
    getDataEnumDumping,
};
